module.exports = __webpack_public_path__ + "img/no-image.a37b37d9.png";